const message = {
  path: 'message/:messageId',
  props: true,
  component: resolve => require(['../../../../components/pages/user/message'], resolve)
}

export default message
